import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Spinner, Center } from '@chakra-ui/react';
import { assessmentService } from '../services/api';
import { generatePDFContent } from '../utils/pdfGenerator';

export const PrintAssessmentPage = () => {
  const { slug } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAndRender = async () => {
      try {
        const response = await assessmentService.getBySlug(slug);
        const assessment = response.data.assessment;

        const scores = typeof assessment.scores === 'string'
          ? JSON.parse(assessment.scores)
          : assessment.scores;

        const formData = typeof assessment.form_data === 'string'
          ? JSON.parse(assessment.form_data)
          : assessment.form_data;

        const html = generatePDFContent({
          name: assessment.name,
          scores,
          formData,
          units: assessment.units || 'metric'
        });

        // Replace the entire document with the PDF content
        document.open();
        document.write(html);
        document.close();

        // Auto-trigger print after a short delay for fonts to load
        setTimeout(() => {
          window.print();
        }, 500);

      } catch (err) {
        setError('Failed to load assessment');
      }
    };

    fetchAndRender();
  }, [slug]);

  if (error) {
    return (
      <Center py={20} flexDirection="column">
        <p>{error}</p>
      </Center>
    );
  }

  return (
    <Center py={20}>
      <Spinner size="xl" color="red.500" />
    </Center>
  );
};

export default PrintAssessmentPage;
